import {Component, EventEmitter, Host, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {OsmService} from '../osm.service';
import {OsmMapComponent} from '../osm-map/osm-map.component';
import {Subject, Subscription} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'osm-polygon',
    templateUrl: './osm-polygon.component.html',
    styleUrls: [
        './osm-polygon.component.scss'
    ],
    standalone: false
})
export class OsmPolygonComponent implements OnInit, OnDestroy {

  private L;
  public polygon;
  private _coordinates;
  public mapSubscribe: Subscription;
  private ngDestroy = new Subject();
  @Output() public ready: EventEmitter<any> = new EventEmitter();

  get coordinates() {
    return this._coordinates;
  }

  @Input() set coordinates(value) {
    this._coordinates = value;
    this.setPosition();
  }

  constructor(private o: OsmService,
              @Host() private host_map: OsmMapComponent) { }


  ngOnInit(): void {
    this.mapSubscribe = this.o.$getMap
      .pipe(takeUntil(this.ngDestroy))
      .subscribe((L) => {
        if (!L) {
          return;
        }

        this.L = L;
        this.whenMapReady();
      });
  }

  whenMapReady() {
    this.polygon = this.L.polygon(this.coordinates, {color: 'red'});
    this.o.registerPolygon(this.polygon, this, this.host_map);
    this.ready.emit(this);
  }

  setPosition() {
    if (this._coordinates && this.polygon) {
      this.polygon.setLatLngs(this._coordinates);
    }
  }

  ngOnDestroy () {
    if (this.mapSubscribe) {
      this.mapSubscribe.unsubscribe();
    }
  }

}
